import { values } from 'lodash'
import PropTypes from 'prop-types'

import { CHALLENGE_TYPES } from '../../common/constants'
import { idPropType } from '../../common/prop-types'

const challengePropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  position: PropTypes.number.isRequired,
  type: PropTypes.oneOf(values(CHALLENGE_TYPES)).isRequired,
  imageUrl: PropTypes.string,
  cuisineTypes: PropTypes.arrayOf(idPropType),
  dishTypes: PropTypes.arrayOf(idPropType),
})

challengePropType.defaultProps = {
  description: undefined,
  imageUrl: undefined,
  cuisineTypes: [],
  dishTypes: [],
}

export default challengePropType
